const RightArrow = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 85" {...props}>
    <path
      fill="currentColor"
      d="M50 50.242V34.758L15.41 0H0v15.484L26.885 42.5 0 69.516V85h15.41ZM13.402 4.758l29.936 30.081-.43.005-6.858-.071L6.26 4.838Zm-8.667 8.71.08-7.177 29.053 29.193-3.612 3.628Zm0 58.065 25.521-25.645 3.612 3.628L4.815 78.71Zm1.525 8.629 29.79-29.935 6.859-.07.43.004-29.937 30.081Z"
    />
  </svg>
);
export default RightArrow;
